/**
 * @copyright 2019 @ DigiNet
 * @author rocachien
 * @create 2019/06/02 03:37
 * @update 2019/06/02 03:37
 * @file src/reducers/setting.js
 */

import * as types from '../actions/types.js';

const initialState = {
    addDevice: null,
};

export default function(state = initialState, action = {}) {
    switch (action.type) {
        case types.ADD_DEVICE_COMPLETE:
            return{
                ...state,
                addDevice: action.addDevice
            };

        default:
            return state;
    }
}